export const FULL = 'Full'
